const data = [
  {
    id: 'generic',
    appearance: 'blue',
    title: 'YOUR OFFER',
    logo: 'generic',
    logoAlt: '',
    isRemovable: true,
    textMain: 'Get 40% off for 12 months',
    textHint: 'Listen to all episodes of Luminary original shows & more on the Luminary app.',
    bottomText: 'Download the Luminary App',
    bottomIcon: 'play',
    straightTitle: 'Luminary Podcasts',
    link: 'https://luminary.link/S1wsJy8Y7nb',
  },
  {
    id: 'test123',
    appearance: 'blue',
    title: 'YOUR OFFER',
    logo: 'https://img2.luminarypodcasts.com/v1/podcast/c88501e3-f783-43cc-b00a-022d2a3ad33b/default/h_500,w_500/image/s--WpH1phRA--/aHR0cHM6Ly9tZWdhcGhvbmUuaW1naXgubmV0L3BvZGNhc3RzL2MxZDE3MzdjLTg1YWEtMTFlYi1iMWVhLTkzMDA3ZDFlZTk3OS9pbWFnZS9NTV9UaWxlX1I1XzEucG5nP2l4bGliPXJhaWxzLTIuMS4yJm1heC13PTMwMDAmbWF4LWg9MzAwMCZmaXQ9Y3JvcCZhdXRvPWZvcm1hdCxjb21wcmVzcw==.png?dpr=3',
    logoAlt: 'The Midnight Miracle',
    isRemovable: true,
    textMain: '<b>FREE 3-Month<b> subscription to Luminary.',
    textHint: 'Listen to all episodes of The Midnight Miracle.',
    bottomText: 'Listen on the Luminary App',
    bottomIcon: 'play',
    straightTitle: 'Luminary Podcasts',
    link: 'https://luminary.link/S1wsJy8Y7nb',
  },
];

// eslint-disable-next-line no-unused-vars
const sampleCodeData = {
  properties: {
    available_quantity: 1,
    campaign: {
      campaign_id: 'test123', created_at: '2022-03-31T06:09:06.023991000Z', description: null, expiration: null, forced_expire: false, status: '0', updated_at: '2022-03-31T06:09:06.023991000Z', uuid: '7a013465-dce8-4bce-a2b5-0ceaa320ded7',
    },
    campaign_uuid: '7a013465-dce8-4bce-a2b5-0ceaa320ded7',
    code: 'xtxVSGpq',
    created_at: '2022-03-31T06:12:46.202086000Z',
    discount: 50,
    discount_type: 'percentage',
    duration: 1,
    initial_quantity: 1,
    maximum_uses: 1,
    promo_request_uuid: 'ecf1b177-7f9a-447c-a532-d5692cf3e06d',
    promo_type: 'single_use',
    status: '1',
    updated_at: '2022-03-31T06:12:46.202086000Z',
    uuid: 'f9e370f4-6193-4413-80af-9e14dde54f7e',
  },
  valid: true,
};

export const getCardDataByCampaign = (id) => {
  const found = data.find(v => v.id === id);
  return found || data.find(v => v.id === 'generic');
};

export const getPromoPlan = (plan, promo) => ({
  ...plan,
  trialPeriodDays: 90,
  trialPeriodForDisplay: '3-Month',
  ...(promo.modifications || {}),
});

export default {
  getCardDataByCampaign,
  getPromoPlan,
};
